/** ISO 4217 — минимальный набор. Расширить при необходимости. */
export const CURRENCIES: ReadonlyArray<{ code: string; name: string }> = [
  { code: 'RUB', name: 'Российский рубль' },
  { code: 'KZT', name: 'Казахстанский тенге' },
  { code: 'BYN', name: 'Белорусский рубль' },
  { code: 'UAH', name: 'Украинская гривна' },
  { code: 'AMD', name: 'Армянский драм' },
  { code: 'GEL', name: 'Грузинский лари' },
  { code: 'AZN', name: 'Азербайджанский манат' },
  { code: 'UZS', name: 'Узбекский сум' },
  { code: 'KGS', name: 'Киргизский сом' },
  { code: 'USD', name: 'Доллар США' },
  { code: 'EUR', name: 'Евро' },
  { code: 'GBP', name: 'Фунт стерлингов' },
  { code: 'CNY', name: 'Китайский юань' },
  { code: 'TRY', name: 'Турецкая лира' },
  { code: 'AED', name: 'Дирхам ОАЭ' },
  { code: 'THB', name: 'Тайский бат' },
];
